"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRIBL_SCHEDULED_EVENT_KEY_HEADER_NAME = exports.CRIBL_REQUEST_ID_HEADER_NAME = exports.CRIBL_USER_ID_HEADER_NAME = exports.GOATOPS_AGENT = exports.ORG_LEADER_AGENT = exports.TYPHON_AGENT = exports.MAESTRO_AGENT = exports.CRIBL_SOURCE_HEADER_NAME = exports.CRIBL_AGENT_HEADER_NAME = void 0;
exports.CRIBL_AGENT_HEADER_NAME = 'X-Cribl-Agent';
exports.CRIBL_SOURCE_HEADER_NAME = 'X-Cribl-Source';
exports.MAESTRO_AGENT = 'maestro';
exports.TYPHON_AGENT = 'typhon';
exports.ORG_LEADER_AGENT = 'org-leader';
/** Agent identifier for GoatOps service-to-service requests. */
exports.GOATOPS_AGENT = 'goatops';
/**
 * The two headers below deliberately omit the `X-` prefix that `CRIBL_AGENT_HEADER_NAME` and
 * `CRIBL_SOURCE_HEADER_NAME` above still carry. IETF deprecated `X-` for custom application
 * headers (RFC 6648), so new headers are added without it rather than adding to the pile that
 * will eventually need migrating. This follows the `Cribl-App` header in the Leader repo
 * (`src/share/constants.ts`), which was added the same way.
 */
/**
 * Identity of the end user whose request caused an outbound call, so the receiver
 * (e.g. a Leader) can attribute the action to a concrete Auth0 id in its audit and
 * access logs instead of to the shared service account it was authenticated as.
 *
 * Purely informational — never use it for authentication or authorization decisions.
 */
exports.CRIBL_USER_ID_HEADER_NAME = 'Cribl-User-Id';
/**
 * Correlation id shared between the caller's logs and the receiver's logs for the
 * same logical request.
 */
exports.CRIBL_REQUEST_ID_HEADER_NAME = 'Cribl-Request-Id';
/**
 * API key EventBridge presents (via an API_KEY connection) to authenticate calls to the
 * Zeus scheduled-events dedup endpoint. Compared against process.env.SCHEDULED_EVENTS_API_KEY
 * (Secrets Manager -> External Secrets -> Helm envFromSecret, not deploy-config) by
 * ScheduledEventKeyGuard; missing/mismatched values are rejected with 401.
 * Keep in sync with scheduled_event_key_header in
 * infrastructure/terraform/zeus/zeus-infra/modules/regional/events.tf.
 */
exports.CRIBL_SCHEDULED_EVENT_KEY_HEADER_NAME = 'Cribl-Scheduled-Event-Key';
